export const DOCUMENT_ATTACHMENT_TYPE = 'document';
export const PHOTO_ATTACHMENT_TYPE = 'photo';
export const FILE_ATTACHMENT_TYPE = 'file';

export const OSS_URN_TYPE = 'oss';
export const DM_URN_TYPE = 'dm';

export const ATTACHMENT_SORT = '-created_at';
export const ATTACHMENT_PAGE_LIMIT = 20;
export const ATTACHMENT_STATUS_COMPLETED = 'completed';

export const MIN_PROGRESS = 5;
export const MAX_PROGRESS = 95;

export const attachmentOrigin = {
  ATTACHMENT_TAB: 'ATTACHMENT_TAB',
  CHANGESET: 'CHANGESET',
  CREATE_FORM: 'CREATE_FORM'
};

export const ATTACHMENTS_ATTRIBUTES = {
  URN_TYPE: 'urnType'
};

export const attachmentActions = {
  DELETE_ATTACHMENT: 'DELETE_ATTACHMENT'
};

export const ATTACHMENT_PERMITTED_ACTIONS = {
  REMOVE_ATTACHMENT: 'remove_attachment'
};
